import { LinkPlainExternal, LinkPlainInternal } from 'src/elements/links/Link.plain';
import { palette } from 'src/styles/colors';
import styled, { css } from 'styled-components';

const anchorStyles = css`
  color: ${palette.accentBlue};
  text-decoration: underline;
  cursor: pointer;
  transition: filter 0.3s;

  p {
    color: ${palette.accentBlue};
  }

  &:hover {
    filter: brightness(1.1);
  }
`;

export const ExternalUrlAnchor = styled(LinkPlainExternal)`
  ${anchorStyles}
`;

export const InternalUrlAnchor = styled(LinkPlainInternal)`
  ${anchorStyles}
`;

export const GoToSectionAnchor = styled.a`
  ${anchorStyles}
`;
